export default __webpack_public_path__ + "static/media/wifi.25daec19.svg";